import styled from 'styled-components';
import ErrorPage404Svg from './d404.svg';

const ErrorPage404 = styled(ErrorPage404Svg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ErrorPage404;
